import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { addEntities, deleteEntities, selectAllEntities, updateEntities, withEntities } from '@ngneat/elf-entities';
import { map } from 'rxjs';

import { InvestorBulkEmailSend } from './investor-bulk-email.model';

@Injectable({ providedIn: 'root' })
export class InvestorBulkEmailRepository {
  private _store$ = createStore(
    { name: 'investor-bulk-email' },
    withEntities<InvestorBulkEmailSend, 'channel'>({ idKey: 'channel' })
  );

  sends$ = this._store$.pipe(selectAllEntities());

  // Tracking starts before the RPC responds, but the card waits for the total:
  // for a large fund the request can take a while and an indeterminate bar
  // that then snaps to a real value is a jarring hand-off.
  visibleSends$ = this.sends$.pipe(
    map((sends) => sends.filter((send) => !send.dismissed && send.total !== undefined))
  );

  addSend(send: InvestorBulkEmailSend): void {
    this._store$.update(addEntities(send));
  }

  getSend(channel: string): InvestorBulkEmailSend | undefined {
    return this._store$.getValue().entities[channel];
  }

  removeSend(channel: string): void {
    this._store$.update(deleteEntities(channel));
  }

  updateSend(channel: string, changes: Partial<InvestorBulkEmailSend>): void {
    this._store$.update(updateEntities(channel, changes));
  }

  reset(): void {
    this._store$.reset();
  }
}
